import * as React from "react";
import {
	cn,
	SURAH_FRAME_GLYPH,
	SURAH_WORD_GLYPH,
	surahNameGlyph,
	surahsNamesMap,
} from "@/lib/utils";

interface SurahHeaderProps {
	number: number;
	className?: string;
}

/**
 * Ornamental surah header as printed in the 1405H Madinah Mushaf: the
 * interlaced frame (quran-common U+E000) in --surah-frame with the calligraphic
 * "سورة <name>" (surah-name) laid over its cartouche in ink. Both glyphs are
 * sized from the container width, so the header scales as one image; set the
 * width on the element (it matches the mushaf line width in the reader).
 */
const SurahHeader: React.FC<SurahHeaderProps> = ({ number, className }) => (
	<div
		role="img"
		aria-label={`Sura ${surahsNamesMap.get(number) ?? number}`}
		translate="no"
		className={cn("relative mx-auto select-none [container-type:inline-size]", className)}
	>
		<span
			aria-hidden
			className="block whitespace-nowrap text-center font-quran-common leading-none text-(--surah-frame) [font-size:calc(100cqi/8.047)]"
		>
			{SURAH_FRAME_GLYPH}
		</span>
		<span
			aria-hidden
			dir="ltr"
			className="absolute inset-0 flex flex-row-reverse items-center justify-center gap-[0.25em] font-surah leading-none text-ink [font-size:calc(100cqi/14)]"
		>
			<span>{SURAH_WORD_GLYPH}</span>
			<span>{surahNameGlyph(number)}</span>
		</span>
	</div>
);

export default React.memo(SurahHeader);
